module.exports = __webpack_public_path__ + "media/images/ohap_assignment indicator_on-d0002d74b512db646faf3a67a0bada4a.png";